import { LifecycleModel } from "./lifecyclemodel";
import { ThirdPartyInformationModel } from "./thirdpartyinformationmodel";
import { OwnershipInformationModel } from "./ownershipinformationmodel";
import { AssetHyperlinkModel } from "./assethyperlinkmodel";

export class AssetManagementModel {
    guid: string;
    name: string = "";
    description: string = "";
    reference: string;
    lifecycle?: LifecycleModel;
    thirdPartyInformation?: ThirdPartyInformationModel;
    ownershipInformation?: OwnershipInformationModel;
    hyperlinks: AssetHyperlinkModel[] = [];
    version: number;
}
